import type { LocaleKey } from "./index";
import {
  BUSINESS_TYPES as EN_US_BUSINESS_TYPES,
  ROLES as EN_US_ROLES,
  SALUTATIONS as EN_US_SALUTATIONS,
} from "./langs/en-US";
import {
  BUSINESS_TYPES as EN_GB_BUSINESS_TYPES,
  ROLES as EN_GB_ROLES,
  SALUTATIONS as EN_GB_SALUTATIONS,
} from "./langs/en-GB";
import {
  BUSINESS_TYPES as FR_FR_BUSINESS_TYPES,
  ROLES as FR_FR_ROLES,
  SALUTATIONS as FR_FR_SALUTATIONS,
} from "./langs/fr-FR";
import {
  BUSINESS_TYPES as DE_DE_BUSINESS_TYPES,
  ROLES as DE_DE_ROLES,
  SALUTATIONS as DE_DE_SALUTATIONS,
} from "./langs/de-DE";
import {
  BUSINESS_TYPES as ES_ES_BUSINESS_TYPES,
  ROLES as ES_ES_ROLES,
  SALUTATIONS as ES_ES_SALUTATIONS,
} from "./langs/es-ES";
import {
  BUSINESS_TYPES as IT_IT_BUSINESS_TYPES,
  ROLES as IT_IT_ROLES,
  SALUTATIONS as IT_IT_SALUTATIONS,
} from "./langs/it-IT";
import {
  BUSINESS_TYPES as JA_JP_BUSINESS_TYPES,
  ROLES as JA_JP_ROLES,
  SALUTATIONS as JA_JP_SALUTATIONS,
} from "./langs/ja-JP";
import {
  BUSINESS_TYPES as NL_NL_BUSINESS_TYPES,
  ROLES as NL_NL_ROLES,
  SALUTATIONS as NL_NL_SALUTATIONS,
} from "./langs/nl-NL";
import {
  BUSINESS_TYPES as PT_BR_BUSINESS_TYPES,
  ROLES as PT_BR_ROLES,
  SALUTATIONS as PT_BR_SALUTATIONS,
} from "./langs/pt-BR";
import {
  BUSINESS_TYPES as PT_PT_BUSINESS_TYPES,
  ROLES as PT_PT_ROLES,
  SALUTATIONS as PT_PT_SALUTATIONS,
} from "./langs/pt-PT";
import {
  BUSINESS_TYPES as EN_AU_BUSINESS_TYPES,
  ROLES as EN_AU_ROLES,
  SALUTATIONS as EN_AU_SALUTATIONS,
} from "./langs/en-AU";
import {
  BUSINESS_TYPES as EN_CA_BUSINESS_TYPES,
  ROLES as EN_CA_ROLES,
  SALUTATIONS as EN_CA_SALUTATIONS,
} from "./langs/en-CA";
import {
  BUSINESS_TYPES as EN_IE_BUSINESS_TYPES,
  ROLES as EN_IE_ROLES,
  SALUTATIONS as EN_IE_SALUTATIONS,
} from "./langs/en-IE";
import {
  BUSINESS_TYPES as EN_NZ_BUSINESS_TYPES,
  ROLES as EN_NZ_ROLES,
  SALUTATIONS as EN_NZ_SALUTATIONS,
} from "./langs/en-NZ";
import {
  BUSINESS_TYPES as EN_ZA_BUSINESS_TYPES,
  ROLES as EN_ZA_ROLES,
  SALUTATIONS as EN_ZA_SALUTATIONS,
} from "./langs/en-ZA";
import {
  BUSINESS_TYPES as DE_AT_BUSINESS_TYPES,
  ROLES as DE_AT_ROLES,
  SALUTATIONS as DE_AT_SALUTATIONS,
} from "./langs/de-AT";
import {
  BUSINESS_TYPES as DE_BE_BUSINESS_TYPES,
  ROLES as DE_BE_ROLES,
  SALUTATIONS as DE_BE_SALUTATIONS,
} from "./langs/de-BE";
import {
  BUSINESS_TYPES as DE_LU_BUSINESS_TYPES,
  ROLES as DE_LU_ROLES,
  SALUTATIONS as DE_LU_SALUTATIONS,
} from "./langs/de-LU";
import {
  BUSINESS_TYPES as ES_AR_BUSINESS_TYPES,
  ROLES as ES_AR_ROLES,
  SALUTATIONS as ES_AR_SALUTATIONS,
} from "./langs/es-AR";
import {
  BUSINESS_TYPES as ES_MX_BUSINESS_TYPES,
  ROLES as ES_MX_ROLES,
  SALUTATIONS as ES_MX_SALUTATIONS,
} from "./langs/es-MX";
import {
  BUSINESS_TYPES as FR_BE_BUSINESS_TYPES,
  ROLES as FR_BE_ROLES,
  SALUTATIONS as FR_BE_SALUTATIONS,
} from "./langs/fr-BE";
import {
  BUSINESS_TYPES as FR_CA_BUSINESS_TYPES,
  ROLES as FR_CA_ROLES,
  SALUTATIONS as FR_CA_SALUTATIONS,
} from "./langs/fr-CA";
import {
  BUSINESS_TYPES as FR_LU_BUSINESS_TYPES,
  ROLES as FR_LU_ROLES,
  SALUTATIONS as FR_LU_SALUTATIONS,
} from "./langs/fr-LU";
import {
  BUSINESS_TYPES as IT_MT_BUSINESS_TYPES,
  ROLES as IT_MT_ROLES,
  SALUTATIONS as IT_MT_SALUTATIONS,
} from "./langs/it-MT";
import {
  BUSINESS_TYPES as NL_BE_BUSINESS_TYPES,
  ROLES as NL_BE_ROLES,
  SALUTATIONS as NL_BE_SALUTATIONS,
} from "./langs/nl-BE";
import {
  BUSINESS_TYPES as BG_BG_BUSINESS_TYPES,
  ROLES as BG_BG_ROLES,
  SALUTATIONS as BG_BG_SALUTATIONS,
} from "./langs/bg-BG";
import {
  BUSINESS_TYPES as CS_CZ_BUSINESS_TYPES,
  ROLES as CS_CZ_ROLES,
  SALUTATIONS as CS_CZ_SALUTATIONS,
} from "./langs/cs-CZ";
import {
  BUSINESS_TYPES as DA_DK_BUSINESS_TYPES,
  ROLES as DA_DK_ROLES,
  SALUTATIONS as DA_DK_SALUTATIONS,
} from "./langs/da-DK";
import {
  BUSINESS_TYPES as EL_CY_BUSINESS_TYPES,
  ROLES as EL_CY_ROLES,
  SALUTATIONS as EL_CY_SALUTATIONS,
} from "./langs/el-CY";
import {
  BUSINESS_TYPES as EL_GR_BUSINESS_TYPES,
  ROLES as EL_GR_ROLES,
  SALUTATIONS as EL_GR_SALUTATIONS,
} from "./langs/el-GR";
import {
  BUSINESS_TYPES as ET_EE_BUSINESS_TYPES,
  ROLES as ET_EE_ROLES,
  SALUTATIONS as ET_EE_SALUTATIONS,
} from "./langs/et-EE";
import {
  BUSINESS_TYPES as FI_FI_BUSINESS_TYPES,
  ROLES as FI_FI_ROLES,
  SALUTATIONS as FI_FI_SALUTATIONS,
} from "./langs/fi-FI";
import {
  BUSINESS_TYPES as HR_HR_BUSINESS_TYPES,
  ROLES as HR_HR_ROLES,
  SALUTATIONS as HR_HR_SALUTATIONS,
} from "./langs/hr-HR";
import {
  BUSINESS_TYPES as HU_HU_BUSINESS_TYPES,
  ROLES as HU_HU_ROLES,
  SALUTATIONS as HU_HU_SALUTATIONS,
} from "./langs/hu-HU";
import {
  BUSINESS_TYPES as ID_ID_BUSINESS_TYPES,
  ROLES as ID_ID_ROLES,
  SALUTATIONS as ID_ID_SALUTATIONS,
} from "./langs/id-ID";
import {
  BUSINESS_TYPES as IS_IS_BUSINESS_TYPES,
  ROLES as IS_IS_ROLES,
  SALUTATIONS as IS_IS_SALUTATIONS,
} from "./langs/is-IS";
import {
  BUSINESS_TYPES as KO_KR_BUSINESS_TYPES,
  ROLES as KO_KR_ROLES,
  SALUTATIONS as KO_KR_SALUTATIONS,
} from "./langs/ko-KR";
import {
  BUSINESS_TYPES as LT_LT_BUSINESS_TYPES,
  ROLES as LT_LT_ROLES,
  SALUTATIONS as LT_LT_SALUTATIONS,
} from "./langs/lt-LT";
import {
  BUSINESS_TYPES as LV_LV_BUSINESS_TYPES,
  ROLES as LV_LV_ROLES,
  SALUTATIONS as LV_LV_SALUTATIONS,
} from "./langs/lv-LV";
import {
  BUSINESS_TYPES as MS_MY_BUSINESS_TYPES,
  ROLES as MS_MY_ROLES,
  SALUTATIONS as MS_MY_SALUTATIONS,
} from "./langs/ms-MY";
import {
  BUSINESS_TYPES as NO_NO_BUSINESS_TYPES,
  ROLES as NO_NO_ROLES,
  SALUTATIONS as NO_NO_SALUTATIONS,
} from "./langs/no-NO";
import {
  BUSINESS_TYPES as PL_PL_BUSINESS_TYPES,
  ROLES as PL_PL_ROLES,
  SALUTATIONS as PL_PL_SALUTATIONS,
} from "./langs/pl-PL";
import {
  BUSINESS_TYPES as RO_RO_BUSINESS_TYPES,
  ROLES as RO_RO_ROLES,
  SALUTATIONS as RO_RO_SALUTATIONS,
} from "./langs/ro-RO";
import {
  BUSINESS_TYPES as RU_RU_BUSINESS_TYPES,
  ROLES as RU_RU_ROLES,
  SALUTATIONS as RU_RU_SALUTATIONS,
} from "./langs/ru-RU";
import {
  BUSINESS_TYPES as RU_UA_BUSINESS_TYPES,
  ROLES as RU_UA_ROLES,
  SALUTATIONS as RU_UA_SALUTATIONS,
} from "./langs/ru-UA";
import {
  BUSINESS_TYPES as SK_SK_BUSINESS_TYPES,
  ROLES as SK_SK_ROLES,
  SALUTATIONS as SK_SK_SALUTATIONS,
} from "./langs/sk-SK";
import {
  BUSINESS_TYPES as SL_SI_BUSINESS_TYPES,
  ROLES as SL_SI_ROLES,
  SALUTATIONS as SL_SI_SALUTATIONS,
} from "./langs/sl-SI";
import {
  BUSINESS_TYPES as SV_SE_BUSINESS_TYPES,
  ROLES as SV_SE_ROLES,
  SALUTATIONS as SV_SE_SALUTATIONS,
} from "./langs/sv-SE";
import {
  BUSINESS_TYPES as TH_TH_BUSINESS_TYPES,
  ROLES as TH_TH_ROLES,
  SALUTATIONS as TH_TH_SALUTATIONS,
} from "./langs/th-TH";
import {
  BUSINESS_TYPES as TR_TR_BUSINESS_TYPES,
  ROLES as TR_TR_ROLES,
  SALUTATIONS as TR_TR_SALUTATIONS,
} from "./langs/tr-TR";
import {
  BUSINESS_TYPES as VI_VN_BUSINESS_TYPES,
  ROLES as VI_VN_ROLES,
  SALUTATIONS as VI_VN_SALUTATIONS,
} from "./langs/vi-VN";
import {
  BUSINESS_TYPES as ZH_CN_BUSINESS_TYPES,
  ROLES as ZH_CN_ROLES,
  SALUTATIONS as ZH_CN_SALUTATIONS,
} from "./langs/zh-CN";

export type CdcOption = {
  id: string;
  label: string;
  value: string;
};

type OptionCollections = {
  businessTypes: ReadonlyArray<CdcOption>;
  roles: ReadonlyArray<CdcOption>;
  salutations: ReadonlyArray<CdcOption>;
};

const OPTIONS_BY_LOCALE: Record<LocaleKey, OptionCollections> = {
  "en-US": {
    businessTypes: EN_US_BUSINESS_TYPES,
    roles: EN_US_ROLES,
    salutations: EN_US_SALUTATIONS,
  },
  "en-GB": {
    businessTypes: EN_GB_BUSINESS_TYPES,
    roles: EN_GB_ROLES,
    salutations: EN_GB_SALUTATIONS,
  },
  "fr-FR": {
    businessTypes: FR_FR_BUSINESS_TYPES,
    roles: FR_FR_ROLES,
    salutations: FR_FR_SALUTATIONS,
  },
  "de-DE": {
    businessTypes: DE_DE_BUSINESS_TYPES,
    roles: DE_DE_ROLES,
    salutations: DE_DE_SALUTATIONS,
  },
  "es-ES": {
    businessTypes: ES_ES_BUSINESS_TYPES,
    roles: ES_ES_ROLES,
    salutations: ES_ES_SALUTATIONS,
  },
  "it-IT": {
    businessTypes: IT_IT_BUSINESS_TYPES,
    roles: IT_IT_ROLES,
    salutations: IT_IT_SALUTATIONS,
  },
  "ja-JP": {
    businessTypes: JA_JP_BUSINESS_TYPES,
    roles: JA_JP_ROLES,
    salutations: JA_JP_SALUTATIONS,
  },
  "nl-NL": {
    businessTypes: NL_NL_BUSINESS_TYPES,
    roles: NL_NL_ROLES,
    salutations: NL_NL_SALUTATIONS,
  },
  "pt-BR": {
    businessTypes: PT_BR_BUSINESS_TYPES,
    roles: PT_BR_ROLES,
    salutations: PT_BR_SALUTATIONS,
  },
  "pt-PT": {
    businessTypes: PT_PT_BUSINESS_TYPES,
    roles: PT_PT_ROLES,
    salutations: PT_PT_SALUTATIONS,
  },
  "en-AU": {
    businessTypes: EN_AU_BUSINESS_TYPES,
    roles: EN_AU_ROLES,
    salutations: EN_AU_SALUTATIONS,
  },
  "en-CA": {
    businessTypes: EN_CA_BUSINESS_TYPES,
    roles: EN_CA_ROLES,
    salutations: EN_CA_SALUTATIONS,
  },
  "en-IE": {
    businessTypes: EN_IE_BUSINESS_TYPES,
    roles: EN_IE_ROLES,
    salutations: EN_IE_SALUTATIONS,
  },
  "en-NZ": {
    businessTypes: EN_NZ_BUSINESS_TYPES,
    roles: EN_NZ_ROLES,
    salutations: EN_NZ_SALUTATIONS,
  },
  "en-IN": {
    businessTypes: EN_US_BUSINESS_TYPES,
    roles: EN_US_ROLES,
    salutations: EN_US_SALUTATIONS,
  },
  "en-ZA": {
    businessTypes: EN_ZA_BUSINESS_TYPES,
    roles: EN_ZA_ROLES,
    salutations: EN_ZA_SALUTATIONS,
  },
  "de-AT": {
    businessTypes: DE_AT_BUSINESS_TYPES,
    roles: DE_AT_ROLES,
    salutations: DE_AT_SALUTATIONS,
  },
  "de-BE": {
    businessTypes: DE_BE_BUSINESS_TYPES,
    roles: DE_BE_ROLES,
    salutations: DE_BE_SALUTATIONS,
  },
  "de-LU": {
    businessTypes: DE_LU_BUSINESS_TYPES,
    roles: DE_LU_ROLES,
    salutations: DE_LU_SALUTATIONS,
  },
  "es-AR": {
    businessTypes: ES_AR_BUSINESS_TYPES,
    roles: ES_AR_ROLES,
    salutations: ES_AR_SALUTATIONS,
  },
  "es-MX": {
    businessTypes: ES_MX_BUSINESS_TYPES,
    roles: ES_MX_ROLES,
    salutations: ES_MX_SALUTATIONS,
  },
  "fr-BE": {
    businessTypes: FR_BE_BUSINESS_TYPES,
    roles: FR_BE_ROLES,
    salutations: FR_BE_SALUTATIONS,
  },
  "fr-CA": {
    businessTypes: FR_CA_BUSINESS_TYPES,
    roles: FR_CA_ROLES,
    salutations: FR_CA_SALUTATIONS,
  },
  "fr-LU": {
    businessTypes: FR_LU_BUSINESS_TYPES,
    roles: FR_LU_ROLES,
    salutations: FR_LU_SALUTATIONS,
  },
  "it-MT": {
    businessTypes: IT_MT_BUSINESS_TYPES,
    roles: IT_MT_ROLES,
    salutations: IT_MT_SALUTATIONS,
  },
  "nl-BE": {
    businessTypes: NL_BE_BUSINESS_TYPES,
    roles: NL_BE_ROLES,
    salutations: NL_BE_SALUTATIONS,
  },
  "bg-BG": {
    businessTypes: BG_BG_BUSINESS_TYPES,
    roles: BG_BG_ROLES,
    salutations: BG_BG_SALUTATIONS,
  },
  "cs-CZ": {
    businessTypes: CS_CZ_BUSINESS_TYPES,
    roles: CS_CZ_ROLES,
    salutations: CS_CZ_SALUTATIONS,
  },
  "da-DK": {
    businessTypes: DA_DK_BUSINESS_TYPES,
    roles: DA_DK_ROLES,
    salutations: DA_DK_SALUTATIONS,
  },
  "el-CY": {
    businessTypes: EL_CY_BUSINESS_TYPES,
    roles: EL_CY_ROLES,
    salutations: EL_CY_SALUTATIONS,
  },
  "el-GR": {
    businessTypes: EL_GR_BUSINESS_TYPES,
    roles: EL_GR_ROLES,
    salutations: EL_GR_SALUTATIONS,
  },
  "et-EE": {
    businessTypes: ET_EE_BUSINESS_TYPES,
    roles: ET_EE_ROLES,
    salutations: ET_EE_SALUTATIONS,
  },
  "fi-FI": {
    businessTypes: FI_FI_BUSINESS_TYPES,
    roles: FI_FI_ROLES,
    salutations: FI_FI_SALUTATIONS,
  },
  "hr-HR": {
    businessTypes: HR_HR_BUSINESS_TYPES,
    roles: HR_HR_ROLES,
    salutations: HR_HR_SALUTATIONS,
  },
  "hu-HU": {
    businessTypes: HU_HU_BUSINESS_TYPES,
    roles: HU_HU_ROLES,
    salutations: HU_HU_SALUTATIONS,
  },
  "id-ID": {
    businessTypes: ID_ID_BUSINESS_TYPES,
    roles: ID_ID_ROLES,
    salutations: ID_ID_SALUTATIONS,
  },
  "is-IS": {
    businessTypes: IS_IS_BUSINESS_TYPES,
    roles: IS_IS_ROLES,
    salutations: IS_IS_SALUTATIONS,
  },
  "ko-KR": {
    businessTypes: KO_KR_BUSINESS_TYPES,
    roles: KO_KR_ROLES,
    salutations: KO_KR_SALUTATIONS,
  },
  "lt-LT": {
    businessTypes: LT_LT_BUSINESS_TYPES,
    roles: LT_LT_ROLES,
    salutations: LT_LT_SALUTATIONS,
  },
  "lv-LV": {
    businessTypes: LV_LV_BUSINESS_TYPES,
    roles: LV_LV_ROLES,
    salutations: LV_LV_SALUTATIONS,
  },
  "ms-MY": {
    businessTypes: MS_MY_BUSINESS_TYPES,
    roles: MS_MY_ROLES,
    salutations: MS_MY_SALUTATIONS,
  },
  "no-NO": {
    businessTypes: NO_NO_BUSINESS_TYPES,
    roles: NO_NO_ROLES,
    salutations: NO_NO_SALUTATIONS,
  },
  "pl-PL": {
    businessTypes: PL_PL_BUSINESS_TYPES,
    roles: PL_PL_ROLES,
    salutations: PL_PL_SALUTATIONS,
  },
  "ro-RO": {
    businessTypes: RO_RO_BUSINESS_TYPES,
    roles: RO_RO_ROLES,
    salutations: RO_RO_SALUTATIONS,
  },
  "ru-RU": {
    businessTypes: RU_RU_BUSINESS_TYPES,
    roles: RU_RU_ROLES,
    salutations: RU_RU_SALUTATIONS,
  },
  "ru-UA": {
    businessTypes: RU_UA_BUSINESS_TYPES,
    roles: RU_UA_ROLES,
    salutations: RU_UA_SALUTATIONS,
  },
  "sk-SK": {
    businessTypes: SK_SK_BUSINESS_TYPES,
    roles: SK_SK_ROLES,
    salutations: SK_SK_SALUTATIONS,
  },
  "sl-SI": {
    businessTypes: SL_SI_BUSINESS_TYPES,
    roles: SL_SI_ROLES,
    salutations: SL_SI_SALUTATIONS,
  },
  "sv-SE": {
    businessTypes: SV_SE_BUSINESS_TYPES,
    roles: SV_SE_ROLES,
    salutations: SV_SE_SALUTATIONS,
  },
  "th-TH": {
    businessTypes: TH_TH_BUSINESS_TYPES,
    roles: TH_TH_ROLES,
    salutations: TH_TH_SALUTATIONS,
  },
  "tr-TR": {
    businessTypes: TR_TR_BUSINESS_TYPES,
    roles: TR_TR_ROLES,
    salutations: TR_TR_SALUTATIONS,
  },
  "vi-VN": {
    businessTypes: VI_VN_BUSINESS_TYPES,
    roles: VI_VN_ROLES,
    salutations: VI_VN_SALUTATIONS,
  },
  "zh-CN": {
    businessTypes: ZH_CN_BUSINESS_TYPES,
    roles: ZH_CN_ROLES,
    salutations: ZH_CN_SALUTATIONS,
  },
} as const;

export function getCdcSalutationOptions(
  locale: LocaleKey,
): ReadonlyArray<CdcOption> {
  const options = OPTIONS_BY_LOCALE[locale]?.salutations;
  return options ?? OPTIONS_BY_LOCALE["en-US"].salutations;
}

export function getCdcRoleOptions(locale: LocaleKey): ReadonlyArray<CdcOption> {
  const options = OPTIONS_BY_LOCALE[locale]?.roles;
  return options ?? OPTIONS_BY_LOCALE["en-US"].roles;
}

export function getCdcBusinessTypeOptions(
  locale: LocaleKey,
): ReadonlyArray<CdcOption> {
  const options = OPTIONS_BY_LOCALE[locale]?.businessTypes;
  return options ?? OPTIONS_BY_LOCALE["en-US"].businessTypes;
}
